exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".k-tab-on-top.k-state-active *{background-color:#222d32;color:#fff !important;font-weight:bolder !important}.k-tab-on-top.k-state-active .badge{-webkit-animation:pulsate 1s ease-out;-webkit-animation-iteration-count:5;opacity:1}@-webkit-keyframes pulsate{0%{-webkit-transform:scale(0.8, 0.8);opacity:.8}50%{opacity:1}100%{-webkit-transform:scale(1.2, 1.2);opacity:.8}}", ""]);

// exports
